import { Select } from 'smooth-ui-sc-next';
import { Props } from "../../../../src/components/Props";
import React from 'react';
export default {
  Select,
  Props,
  React
};